import React from 'react';
import { Text } from '@fluentui/react';
import { TableRowType } from './TableRowComponent';

interface TableHeaderComponentProps {
  row: TableRowType;
}

export const TableHeaderComponent: React.FunctionComponent<TableHeaderComponentProps> = props => {
  return (
    <>
      {props.row &&
        Object.keys(props.row).map((key, index) => {
          return (
            <th key={index} className="py-3 px-4 text-nowrap">
              <Text variant="mediumPlus">{key}</Text>
            </th>
          );
        })}
    </>
  );
};
